<template>
  <div style="background-color: #edf4f9;">
  <div class="container p-5">
    <h2 style="font-style: italic; color: #084e8b; font-weight: 700">
      Artikel
    </h2>
    <div class="row mt-2 mb-4 d-flex justify-content-center">
      <div class="col-md-3 col-6 mb-3">
              <button
                class="card card-fixed"
                data-bs-toggle="modal"
                data-bs-target="#art1"
              >
                <div class="card-body text-start">
                <img src="@/assets/artikel/Artikel_1.jpeg" class="img-fixed" />
                  <h5 class="card-title">
                    Berdayakan Kelompok Wanita, PI Utilitas Bentuk Bank Sampah
                    Desa Banyuwangi
                  </h5>

                  <p class="card-text text-start">
                    <small class="text-body-secondaryy">11 November 2022</small>
                  </p>
                </div>
              </button>
            </div>

            <!-- Modal -->

            <div class="modal fade" id="art1" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                      Berdayakan Kelompok Wanita, PI Utilitas Bentuk Bank Sampah
                      Desa Banyuwangi
                    </h2>
                    <!-- <div class="row">
                                                <div class="col-md-6 mb-3"> -->
                    <img
                      src="@/assets/artikel/Artikel_1.jpeg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >11 November 2022</small
                      >
                    </p>
                    <!-- </div>
                                                <div class="col-md-6"> -->
                    <p class="head-modal">"Berilah kail, jangan ikannya."</p>
                    <p class="text-justify">
                      Makna dari pepatah inilah yang menjadi semangat PI
                      Utilitas dalam menjalankan program Corporate Social
                      Responsibility (CSR). Mewujudkan kemandirian masyarakat
                      melalui pemberdayaan dilakukan agar program yang dilakukan
                      memenuhi prinsip berkelanjutan. Artinya, PI Utilitas
                      menjadi pendamping dengan peran dominan di awal program,
                      yang selanjutnya diharapkan mampu berdikari mengelola
                      kegiatannya sendiri.
                    </p>

                    <p class="text-justify">
                      Dengan prinsip di atas, PI Utilitas melakukan rangkaian
                      pendampingan pembentukan program Bank Sampah di Desa
                      Banyuwangi, Gresik, Jawa Timur. Said Ridho Fadlan, Plt.
                      Sekretaris Perusahaan menjelaskan bahwa kegiatan ini
                      merupakan sub program CSR PI Utilitas yaitu Desa Wisata
                      Terintegrasi dan Berkelanjutan ‘Desibel’ Pecuk Indah
                      Ecoriparian.
                    </p>

                    <p class="text-justify">
                      Ridho sapaan akrabnya, juga menambahkan bahwa inisiasi
                      pembentukan Bank Sampah dilatarbelakangi oleh kesadaran
                      masyarakat sekitar desa wisata untuk mengelola sampah yang
                      masih perlu ditingkatkan guna mewujudkan lingkungan yang
                      bersih sebagai syarat utama kenyamanan wisatawan yang
                      berkunjung. Selain itu, program Bank Sampah ini mampu
                      menjadi komoditi ekonomi baru bagi masyarakat Desa
                      Banyuwangi.
                    </p>

                    <p class="text-justify">
                      Rangkaian program ini diawali pada tanggal 29 Oktober 2022
                      dengan memberikan edukasi mengenai pengelolaan sistem Bank
                      Sampah kepada 45 peserta dari kelompok wanita di Desa
                      Banyuwangi. Bekerjasama dengan tim ahli dari Yayasan Esa
                      Khatulistiwa dan LSM setempat, peserta dikenalkan mulai
                      dari pentingnya peran Bank Sampah, jenis-jenis sampah,
                      hingga administrasi manajemen Bank Sampah. Hasilnya,
                      terbentuk Bank Sampah induk tingkat desa yang mengelola 13
                      kelompok Bank Sampah dari setiap Rukun Tetangga (RT).
                    </p>
                    <!-- </div> -->

                    <p class="text-justify">
                      Selanjutnya, program dilanjutkan dengan penyerahan
                      alat-alat Bank Sampah pada tanggal 10 November 2022.
                      Alat-alat yang diberikan berupa buku register, buku
                      tabungan nasabah, serta prasarana lain seperti timbangan,
                      sarung tangan, cutter, dan karung sampah.
                    </p>

                    <p class="text-justify">
                      “Rangkaian program ini akan terus berlanjut dengan
                      pendampingan kepada para peserta dan senantiasa kami akan
                      jalin kolaborasi dengan para stakeholders terkait,
                      utamanya Pemerintah Desa Banyuwangi”, pungkas Ridho. (MA)
                    </p>

                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- end of modal -->

            <div class="col-md-3 col-6 mb-3">
              <button
                class="card card-fixed"
                data-bs-toggle="modal"
                data-bs-target="#art2"
              >
                <div class="card-body text-start">
                <img src="@/assets/artikel/Artikel_2.jpg" class="img-fixed" />
                  <h5 class="card-title">
                    Terus Kembangkan Potensi, PI Utilitas Bekali Warga Cara
                    Mengolah Buah Nipah
                  </h5>

                  <p class="card-text text-start">
                    <small class="text-body-secondaryy">28 Oktober 2022</small>
                  </p>
                </div>
              </button>
            </div>

            <!-- Modal -->

            <div class="modal fade" id="art2" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                      Terus Kembangkan Potensi, PI Utilitas Bekali Warga Cara
                      Mengolah Buah Nipah
                    </h2>
                    <!-- <div class="row">
                                                <div class="col-md-6 mb-3"> -->
                    <img
                      src="@/assets/artikel/Artikel_2.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >28 Oktober 2022</small
                      >
                    </p>
                    <!-- </div>
                                                <div class="col-md-6"> -->
                    <p class="head-modal">Gresik, Jawa Timur</p>
                    <p class="text-justify">
                      PI Utilitas terus mengembangkan potensi Desa Wisata binaan
                      yang menjadi program CSR PI Utilitas yaitu Desa Wisata
                      Terintegrasi dan Berkelanjutan “Desibel” Pecuk Indah
                      Ecoriparian melalui optimalisasi potensi hasil alam yang
                      ada di wilayah desa wisata berupa buah nipah yang
                      diwujudkan dalam program “Pelatihan Cara Mengolah Buah
                      Nipah” yang dilaksanakan pada tanggal 12 dan 13 Oktober
                      2022.
                    </p>

                    <p class="text-justify">
                      Kegiatan yang bertempat di Aula Gazebo Pecuk Indah
                      Ecoriparian ini diikuti oleh 37 peserta dari kelompok
                      masyarakat lokal yaitu Kelompok Pemberdayaan dan
                      Kesejahteraan Keluarga (PKK), Kelompok Sadar Wisata
                      (Pokdarwis), dan Perangkat Desa Banyuwangi, Gresik, Jawa
                      Timur.
                    </p>

                    <p class="text-justify">
                      Buah Nipah, yang memiliki nama ilmiah Nypa fruticans,
                      tumbuh subur di Kawasan Pecuk Indah Ecoriparian, tetapi
                      keberadaannya kurang diperhatikan dan dimanfaatkan oleh
                      warga setempat. Padahal buah nipah termasuk bahan pangan
                      potensial yang dapat diolah menjadi berbagai macam produk
                      pangan alternatif. Kandungan karbohidrat dan antioksidan
                      alami yang tinggi dalam buah nipah juga membuat buah ini
                      memiliki banyak manfaat seperti menurunkan risiko penyakit
                      kanker dan diabetes, serta menangkal radikal bebas.
                    </p>

                    <p class="text-justify">
                      Bekerjasama dengan tim ahli dari Universitas Negeri
                      Sebelas Maret (UNS) Surakarta dan Lembaga Swadaya
                      Masyarakat (LSM) lokal, PI Utilitas menghadirkan pelatihan
                      mengolah buah nipah menjadi produk olahan berupa sirup,
                      manisan kering, tepung, dan dodol.
                    </p>
                    <!-- </div> -->

                    <p class="text-justify">
                      Plt. Sekretaris Perusahaan PI Utilitas, Said Ridho Fadlan,
                      atau Ridho sapaan akrabnya, mengungkapkan bahwa selain
                      untuk memaksimalkan potensi alam Desa Wisata Pecuk Indah
                      Ecoriparian, pelatihan ini bertujuan untuk meningkatkan
                      kapasitas masyarakat dengan harapan dapat menambah
                      kesiapan kelompok masyarakat setempat untuk menjadi
                      kelompok binaan CSR PI Utilitas yang mandiri dan berdaya
                      dalam mengelola Desa Wisata.
                    </p>

                    <p class="text-justify">
                      "Kedepannya, PI Utilitas akan terus meningkatkan nilai
                      tambah produk dengan pelatihan pengemasan dan pemasaran
                      sehingga produk dapat dijadikan buah tangan khas dari
                      Pecuk Indah Ecoriparian,” tukasnya.
                    </p>

                    <p class="text-justify">
                      Menurutnya, keterlibatan berbagai pihak mulai dari
                      Pemerintah Desa Banyuwangi, Komunitas-komunitas lokal, dan
                      para akademisi sangat membantu keberhasilan pengembangan
                      program Desa Wisata Terintegrasi dan Berkelanjutan
                      “Desibel” Pecuk Indah Ecoriparian. Meskipun ada berbagai
                      tantangan, lanjut Ridho, kolaborasi serta komunikasi dari
                      semua pihak dapat menjadi kunci keberlangsungan program
                      ini.
                    </p>

                    <p class="text-justify">
                      “PI Utilitas akan terus berkomitmen memberikan manfaat
                      yang bernilai tambah bagi masyarakat dan lingkungan dalam
                      setiap operasional bisnisnya sebagai bagian dari strategi
                      dan kontribusi Perusahaan untuk mencapai Sustainable
                      Development Goas (SDGs) atau Tujuan Pembangunan
                      Berkelanjutan (TPB) khususnya nomor 8 tentang pekerjaan
                      layak dan pertumbuhan ekonomi”, tutup RIdho. (MA)
                    </p>

                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- end of modal -->

            <div class="col-md-3 col-6 mb-3">
              <button
                class="card card-fixed"
                data-bs-toggle="modal"
                data-bs-target="#art3"
              >
                <div class="card-body text-start">
                <img src="@/assets/artikel/Artikel_3.jpg" class="img-fixed" />
                  <h5 class="card-title">
                    Komisi VII DPR RI Lakukan Kunjungan Kerja Spesifik ke GGCP
                  </h5>

                  <p class="card-text text-start">
                    <small class="text-body-secondaryy"
                      >17 September 2022</small
                    >
                  </p>
                </div>
              </button>
            </div>

            <!-- Modal -->

            <div class="modal fade" id="art3" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                      Komisi VII DPR RI Lakukan Kunjungan Kerja Spesifik ke GGCP
                    </h2>
                    <!-- <div class="row">
                                                <div class="col-md-6 mb-3"> -->
                    <img
                      src="@/assets/artikel/Artikel_3.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >17 September 2022</small
                      >
                    </p>
                    <!-- </div>
                                                <div class="col-md-6"> -->
                    <p class="text-justify">
                      Kamis, 15 September 2022, Jajaran Komisaris, Direksi, dan
                      Karyawan PT Pupuk Indonesia Utilitas (PI Utilitas)
                      menerima Kunjungan Kerja Spesifik Komisi VII DPR RI di
                      pabrik PI Utilitas yaitu Gresik Gas Cogeneration Plant
                      (GGCP), Gresik, Jawa Timur. Adapun Komisi VII merupakan
                      komisi yang memiliki tugas pada ruang lingkup energi,
                      riset dan inovasi, serta industri.
                    </p>

                    <p class="text-justify">
                      Turut hadir dalam kunjungan ini, Tifatul Sembiring selaku
                      Pimpinan Kunjungan Kerja Spesifik Komisi VII DPR RI ke
                      GGCP beserta anggota Komisi VII DPR RI, Bob Indiarto
                      selaku Direktur Produksi PT Pupuk Indonesia (Persero),
                      serta Direktur Operasi dan Produksi PT Petrokimia Gresik,
                      Digna Jatiningsih.
                    </p>

                    <p class="text-justify">
                      Kunjungan kerja spesifik ini dalam rangka melihat kinerja
                      perusahaan dan memastikan subsidi gas yang diberikan oleh
                      pemerintah untuk mengelola pupuk dapat dengan mudah
                      diperoleh masyarakat, khususnya petani.
                    </p>

                    <p class="text-justify">
                      Dalam sambutanya, Anis Ernani selaku Direktur Operasi PI
                      Utilitas menyambut baik kegiatan kunjungan kerja Komisi
                      VII DPR RI ke pabrik milik PI Utilitas yang terletak di
                      Gresik ini. Selain itu, di hadapan jajaran komisi VII DPR
                      RI, Anis menyampaikan paparan mengenai profil perusahaan,
                      sejumlah portofolio bisnis, serta rencana strategis
                      ekspansi bisnis PI Utilitas kedepan.
                    </p>
                    <!-- </div> -->

                    <p class="text-justify">
                      PI Utilitas memiliki peta jalan pengembangan strategi
                      usaha hingga 2024 yang berorientasi pada ekspansi dan
                      diversifikasi bisnis. Hal ini sebagai upaya untuk
                      menghadapi dinamika bisnis global yang menuntut perusahaan
                      untuk selalu berinovasi dan bertransformasi.
                    </p>
                    <p class="text-justify">
                      “Saat ini PI Utilitas sedang melakukan rencana pembangunan
                      Cikampek Nitrogen & Oxygen Plant (CNOP) yang akan
                      memproduksi nitrogen dengan kapasitas 1.200 Nm3/h dan
                      oksigen berkapasitas 314 Nm3/h di Kawasan Cikampek, Jawa
                      Barat,” ujar anis. Proyek CNOP saat ini masih dalam
                      tahapan proses tender dan ditargetkan beroperasi secara
                      komersial pada triwulan II tahun 2024,” katanya.
                    </p>

                    <p class="text-justify">
                      Pembangunan CNOP ini menjadi bagian program perseroan
                      dalam melakukan diversifikasi produk yang nantinya akan
                      menghasilkan produk Nitrogen yang akan digunakan oleh PT
                      Pupuk Kujang Cikampek (PKC) dan produk Oksigen yang akan
                      dijual ke fasilitas Kesehatan yang masih cukup besar juga
                      kebutuhannya.
                    </p>

                    <p class="text-justify">
                      “Dengan melakukan diversifikasi portofolio sebagai
                      produsen gas industri, maka PI Utilitas akan menjadi
                      perusahaan penyedia utilitas industri terintegrasi
                      (Listrik, Steam, Gas Industri, dll) dan bermanfaat bagi
                      masyarakat luas,” ujar Anis kembali.
                    </p>

                    <p class="text-justify">
                      “Selain itu PI Utilitas juga sedang mempersiapkan rencana
                      akuisisi salah satu perusahaan pembangkit listrik yang
                      insya Allah akan terealisasi pada tahun ini,” tambah Anis.
                    </p>

                    <p class="text-justify">
                      Rencana akuisisi salah satu perusahaan pembangkit listrik
                      yang berlokasi di wilayah Indonesia bagian tengan dan
                      timur akan menjadi enabler untuk PI Utilitas menjual
                      listrik ke luar Pupuk Indonesia Grup, dan hal iniakan
                      membuka peluang pengembangan Pembangkit Listrik Tenaga Uap
                      (PLTU) EBT di wilayah Indonesia bagian tengah dan timur
                      dikarenakan besarnya potensi pengembangan EBT di daerah
                      sana. salah satu arahan strategis yang akan dijalankan
                      oleh PIUtilitas pada Pabrik PLTU yang akan di akusisi
                      adalah melakukan program cofiring biomassa pada kisaran
                      5-10% dari total penggunaan Batu Bara sehingga dapat
                      berkontribusi terhadap peningkatan bauran EBT Nasional.
                      Akuisisi Pembangkitan listrik ini telah direncanakan dalam
                      Rencana Jangka Panjang Perusahaan (RJPP) PI-Utilitas
                      Periode 2020- 2024.
                    </p>

                    <p class="text-justify">
                      Dengan berbagai proyek strategis ini, wilayah operasi PI
                      Utilitas pun akan semakin luas. Sebelumnya, PI Utilitas
                      memiliki wilayah operasi di Jakarta yaitu Head Office,
                      Pabrik GGCP yang berlokasi di Gresik, Jawa Timur dan di
                      Bontang, Kalimantan Timur yaitu tempat berdirinya PT
                      Kaltim Daya Mandiri (KDM) sebagai anak perusahaan.
                      Kedepannya, wilayah operasi akan terus bertambah seiring
                      dengan rencana strategis pengembangan perseroan yang akan
                      segera direalisasikan.
                    </p>

                    <p class="text-justify">
                      Selanjutnya, Anis juga menyampaikan ucapan terimakasih
                      atas sejumlah arahan dan dukungan yang disampaikan oleh
                      Komisi VII DPR RI kepada PI Utilitas.
                    </p>

                    <p class="text-justify">
                      “Kami mengucapkan terima kasih sebesar-besarnya atas
                      kunjungan yang dilakukan Komisi VII DPR RI serta atas
                      arahan dan dukungan kepada PI Utilitas untuk senantiasa
                      melakukan transformasi bisnis melalui ekspansi sehingga
                      menghasilkan produk yang lain yang dapat dirasakan
                      manfaatnya oleh masyarakat,” pungkas Anis. (MA)
                    </p>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- end of modal -->

      <div class="col-md-2 col-6 mb-3">
        <router-link class="card card-more" to="/artikel">
          <div
            class="card-body text-start d-flex flex-column align-items-center justify-content-center"
          >
            <h5 class="card-title mb-0" style="text-align: center">
              Artikel Lainnya
            </h5>
            <img src="../assets/Arrow-right-resized.png" />
          </div>
        </router-link>
      </div>
    </div>
      <h2 style="font-style: italic; color: #084e8b; font-weight: 700">
        Siaran Pers
      </h2>
    <div class="row mt-2 d-flex justify-content-center">
      <div class="col-md-3 col-6 mb-3">
              <button
                class="card card-fixed"
                data-bs-toggle="modal"
                data-bs-target="#pers1"
              >
                <div class="card-body">
                <img src="@/assets/siaranPers/SP-1.jpg" class="img-fixed" />
                  <h5 class="card-title text-start">
                    PT Pupuk Indonesia Utilitas Raih Indonesian Quality Award
                    2022
                  </h5>

                  <p class="card-text text-start">
                    <small class="text-body-secondaryy">13 Desember 2022</small>
                  </p>
                </div>
              </button>
            </div>
            <!-- Modal -->
            <div class="modal fade" id="pers1" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                      PT Pupuk Indonesia Utilitas Raih Indonesian Quality Award
                      2022
                    </h2>
                    <img
                      src="@/assets/siaranPers/SP-1.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >13 Desember 2022</small
                      >
                    </p>

                    <p class="text-justify">
                      PT Pupuk Indonesia Utilitas berhasil meraih penghargaan
                      dalam ajang Indonesian Quality Award (IQA) tahun 2022 yang
                      diselenggarakan oleh Indonesian Quality Award Foundation
                      (IQAF) bersama BUMN Executive Club (BEC) di hotel Fairmont
                      Jakarta pada Senin, 12 Desember 2022. Dalam ajang ini, PT
                      Pupuk Indonesia Utilitas berhasil meraih predikat “Good
                      Performance” dengan skor 508 atau mengalami peningkatan 31
                      poin dari pencapaian tahun sebelumnya yaitu 477
                      (berdasarkan penilaian KPKU)
                    </p>

                    <p class="text-justify">
                      Untuk diketahui, Good Performance adalah kategori dalam
                      asesmen dengan implementasi kerangka BEF yang memiliki
                      skor 476-575.
                    </p>

                    <p class="text-justify">
                      IQA merupakan bentuk penghargaan terhadap penilaian
                      kinerja ekselen berbasiskan Kriteria Baldrige atau yang
                      juga dikenal dengan istilah Malcolm Baldrige Criteria for
                      Performance Excellence (MBCfPE).
                    </p>

                    <p class="text-justify">
                      Penilaian mengacu pada kriteria kinerja ekselen Malcolm
                      Baldrige Education Critera for Performance Excellence.
                      Kriteria ini terdiri dari tujuh kategori, yaitu
                      leadership, strategic planning, customer focus,
                      measurement analysis & knowledge management, workforce
                      focus, Process Management, dan result.
                    </p>

                    <p class="text-justify">
                      Direktur Utama PT Pupuk Indonesia Utilitas, Agus Subekti
                      mengatakan bahwa penghargaan ini sebagai komitmen untuk
                      mendorong kinerja unggul perusahaan sekaligus menjadi
                      semangat bagi kami untuk terus melakukan transformasi
                      bisnis dan meningkatkan kinerja perusahaan ditengah
                      tantangan atas ketidakpastian lingkungan bisnis dan
                      ekonomi global.
                    </p>

                    <p class="text-justify">
                      Kegiatan penilaian ini akan menjadi agenda rutin
                      perusahaan dalam penerapan Baldridge Excellence Framework
                      (BFF) yang berkelanjutan sehingga dapat membantu
                      peningkatan kinerja pada tahun-tahun selanjutnya.
                    </p>

                    <p class="text-justify">
                      Adapun tema yang diusung pada tahun 2022 ini “Membangun
                      Ketangguhan Organisasi Untuk Pemulihan Nasional dan Unggul
                      Dalam Persaiangan Global”. Tema ini sejalan dengan
                      semangat perusahaan yang dibuktikan dengan mencatatkan
                      pencapaian kinerja yang baik dan meningkat dimasa Covid-19
                      serta mampu menjawab tantangan yang ada pada lingkungan
                      bisnis dan ketidakpastian ekonomi global melalui 5 (lima)
                      strategi yang diterapkan perusahaan, pertama meningkatkan
                      kehandalan pabrik, kedua meningkatkan kompetensi Sumber
                      Daya Manusia (SDM) yang dimiliki, ketiga menjaga tingkat
                      kesehatan karyawan, keempat melakukan efisiensi biaya dan
                      yang terakhir atau kelima sekaligus yang terpenting adalah
                      menjaga kepuasan pelanggan”.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-6 mb-3">
              <button
                class="card card-fixed"
                data-bs-toggle="modal"
                data-bs-target="#pers2"
              >
                <div class="card-body">
                <img src="@/assets/siaranPers/SP-2.jpg" class="img-fixed" />
                  <h5 class="card-title text-start">
                    Pupuk Indonesia Lunurkan Program Kompetisi Jurnalistik
                  </h5>

                  <p class="card-text text-start">
                    <small class="text-body-secondaryy">5 Oktober 2022</small>
                  </p>
                </div>
              </button>
            </div>
            <!-- Modal -->
            <div class="modal fade" id="pers2" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                      Pupuk Indonesia Lunurkan Program Kompetisi Jurnalistik
                    </h2>
                    <img
                      src="@/assets/siaranPers/SP-2.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy">5 Oktober 2022</small>
                    </p>

                    <p class="text-justify">
                      PT Pupuk Indonesia (Persero) resmi membuka program
                      kompetisi karya jurnalistik Pupuk Indonesia Media Award
                      (PIMA) 2022. Dengan mengusung tema besar “Makmur Bersama
                      Indonesia”, kompetisi ini terbuka bagi seluruh wartawan,
                      baik dari media massa tingkat nasional maupun seluruh
                      media massa di daerah.
                    </p>

                    <p class="text-justify">
                      SVP Komunikasi Korporat, Wijaya Laksana, menyatakan bahwa
                      program ini masih dalam rangka peringatan satu dekade
                      Pupuk Indonesia pada tahun 2022. Wijaya menyebutkan bahwa
                      ajang ini adalah perdana bagi perusahaan. Oleh karena itu,
                      PIMA 2022 diharapkan dapat memperkenalkan lebih jauh
                      tentang industri pupuk dan transformasi bisnis di Pupuk
                      Indonesia dan anak perusahaannya.
                    </p>

                    <p class="text-justify">
                      “Selain itu, program ini juga bentuk apresiasi kami atas
                      kinerja serta dukungan seluruh wartawan melalui berbagai
                      publikasi seputar bisnis utama hingga aktivitas
                      operasional perusahaan, baik terkait Pupuk Indonesia
                      maupun anak perusahaan,” jelas Wijaya.
                    </p>

                    <p class="text-justify">
                      Lebih lanjut Wijaya menyebutkan bahwa tujuan lain dari
                      program ini adalah untuk menjadi sarana edukasi dan
                      sosialisasi, khususnya bagi wartawan maupun masyarakat
                      pada umumnya. Mulai dari kontribusi perusahaan pada sektor
                      pertanian hingga berbagai program transformasi bisnis
                      Pupuk Indonesia. Karena saat ini Pupuk Indonesia dan anak
                      perusahannya tengah melakukan banyak terobosan dan inovasi
                      di berbagai bidang untuk meningkatkan daya saing.
                    </p>

                    <p class="text-justify">
                      Pupuk Indonesia sendiri telah menjalankan program
                      transformasi bisnis sejak tahun 2020. Program ini menyasar
                      ke berbagai lini bisnis perusahaan, mulai dari bidang
                      produksi, supply chain atau distribusi, pemasaran, SDM
                      atau human capital, pengembangan, digitalisasi, hingga
                      berbagai program lainnya yang berkontribusi terhadap
                      sektor pertanian dan perekonomian nasional.
                    </p>

                    <p class="text-justify">
                      Oleh karena itu, kompetisi jurnalistik ini tidak hanya
                      terbatas pada publikasi seputar kinerja Pupuk Indonesia
                      saja. Melainkan juga publikasi kinerja dan aktivitas dari
                      kesepuluh anak perusahaannya. Adapun kesepuluh anak usaha
                      Pupuk Indonesia adalah PT Pupuk Iskandar Muda, PT Pupuk
                      Sriwidjadja Palembang, PT Pupuk Kujang Cikampek, PT Pupuk
                      Kalimantan Timur, PT Petrokimia Gresik, PT Rekayasa
                      Industri, PT Mega Eltra, PT Pupuk Indonesia Utilitas, PT
                      Pupuk Indonesia Pangan, dan PT Pupuk Indonesia Logistik.
                    </p>

                    <p class="text-justify">
                      Setidaknya terdapat dua sub tema dalam ajang ini. Pertama,
                      terkait upaya Pupuk Indonesia dan anak perusahannya dalam
                      mendukung produktivitas pertanian melalui penyediaan pupuk
                      dan nutrisi tanaman, hingga membangun ekosistem pertanian.
                      Sub tema kedua, transformasi Pupuk Indonesia dan anak
                      perusahaannya dalam beradaptasi di era disruptif guna
                      meningkatkan daya saing bisnis dan kontribusi terhadap
                      perekonomian nasional.
                    </p>

                    <p class="text-justify">
                      Dalam ajang ini, Pupuk Indonesia akan memberikan apresiasi
                      ratusan juta rupiah untuk seluruh pemenang dan nominasi.
                      Adapaun kategori dalam kompetisi ini terdiri dari kategori
                      Media Cetak, Media Online, Media Televisi, dan Fotografi.
                      Sedangkan untuk periode lomba berlaku mulai bulan
                      September hingga November 2022. Penghargaan sendiri
                      direncanakan akan digelar pada bulan Desember 2022.
                    </p>

                    <p class="text-justify">
                      “Semoga melalui program ini publik semakin mendapat banyak
                      informasi dan pengetahuan, khususnya tentang kinerja dan
                      beragam inovasi dan transformasi Pupuk Indonesia grup
                      dalam mendukung program ketahanan pangan nasional dan
                      berkontribusi dalam perekonomian nasional,” tutup Wijaya.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-6 mb-3">
              <button
                class="card card-fixed"
                data-bs-toggle="modal"
                data-bs-target="#pers3"
              >
                <div class="card-body text-start">
                <img src="@/assets/siaranPers/SP-3.jpg" class="img-fixed" />
                  <h5 class="card-title">
                    Pupuk Indonesia Utilitas Raih Tiga Penghargaan di Ajang TOP
                    GRC Awards 2022
                  </h5>

                  <p class="card-text text-start">
                    <small class="text-body-secondaryy">7 September 2022</small>
                  </p>
                </div>
              </button>
            </div>
            <!-- Modal -->
            <div class="modal fade" id="pers3" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                      Pupuk Indonesia Utilitas Raih Tiga Penghargaan di Ajang
                      TOP GRC Awards 2022
                    </h2>
                    <img
                      src="@/assets/siaranPers/SP-3.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >7 September 2022</small
                      >
                    </p>

                    <p class="text-justify">
                      Setiap hasil review, evaluasi dan audit bisa dijadikan
                      pengembangan perbaikan. Perseroan juga sedang
                      mengembangkan BCMS (Business Continuity Management
                      System).
                    </p>

                    <p class="text-justify">
                      Pupuk Indonesia Utilitas (PI Utilitas), salah satu anak
                      perusahaan Pupuk Indonesia (Persero) berhasil meraih tiga
                      penghargaan TOP Governance, Risk and Compilance (Tata
                      Kelola, Risiko dan Kepatuhan) Awards 2022 yang digelar di
                      Hotel Raffles, Jakarta, Selasa, 6 September 2022.
                    </p>

                    <p class="text-justify">
                      Berdasarkan hasil penilain dewan juri, pada tahun ini PI
                      Utilitas meraih penghargaan sebagai berikut:
                    </p>

                    <ol>
                      <li>
                        The most committed GRC Leader 2022 : Direktur Utama PI
                        Utilitas Agus Subekti.
                      </li>
                      <li>Three Star Top GRC Award 2022 untuk PI Utilitas.</li>
                      <li>
                        Special appreciation of Top GRC Award 2022 on Top
                        Special Recognition untuk PI Utilitas.
                      </li>
                    </ol>

                    <p class="text-justify">
                      Direktur Utama PI Utilitas, Agus Subekti, usai menerima
                      penghargaan mengemukakan jika pandemi Covid-19 memang
                      telah memberikan pengaruh terhadap kinerja perseroan pada
                      2021. Agus mencatat ada lima pengaruh yaitu, pertama
                      adanya pengaturan sistem kerja, mulai dari Work from Home
                      (WFH), Work from Office (WFO) hingga pengaturan jadwal
                      kerja/shift.
                    </p>

                    <p class="text-justify">
                      Selanjutnya yang kedua menurut Agus adalah
                      penerapan/implementasi digital office. Kemudian yang
                      ketiga adalah optimalisasi fasilitas teknologi berbasis
                      digital seperti zoom meeting, google meet dan microsoft
                      teams. Keempat adalah penerapan protokol kesehatan
                      (prokes) yaitu 5M (Mencuci tangan, Memakai masker, Menjaga
                      jarak, Menjauhi kerumunan, Mengurangi mobilitas).
                    </p>

                    <p class="text-justify">
                      “Terakhir atau kelima adalah efisiensi biaya administrasi
                      umum,” katanya.
                    </p>
                    <p class="text-justify">
                      Sebagai upaya antisipasi agar pandemi tidak terlalu
                      berpengaruh terhadap kinerja perseroan, Agus mengatakan
                      ada lima strategi yang diterapkan perusahaan yang
                      dipimpinnya yaitu, pertama meningkatkan keandalan pabrik,
                      kedua meningkatkan kompetensi sumber daya manusia (SDM)
                      yang dimiliki oleh perseroan, ketiga menjaga kesehatan SDM
                      dan keempat adalah dengan melakukan efisiensi biaya.
                    </p>

                    <p class="text-justify">
                      “Terakhir atau yang kelima sekaligus yang terpenting
                      adalah menjaga kepuasan pelanggan,” ujarnya.
                    </p>

                    <p class="text-justify">
                      Agus mengutarakan PI Utilitas mampu menjawab tantangan
                      atas ketidakpastian lingkungan bisnis dan ekonomi global
                      melalui kedisiplinan penerapan GRC secara terpadu dan
                      terkoordinasi. Agus mengatakan GRC adalah cerminan
                      komitmen PI Utilitas untuk mengembangkan kebijakan dan
                      meningkatkan tata kelola perusahaan, manajemen risiko dan
                      kepatuhan terhadap regulasi.
                    </p>

                    <p class="text-justify">
                      "Sehingga akuntabilitas atas proses yang dijalankan dapat
                      selalu terjaga," katanya.
                    </p>

                    <p class="text-justify">
                      Dalam penerapan tata kelola dan kepatuhan, Agus
                      menjelaskan PI Utilitas juga telah mengembangkan antara
                      lain melalui implementasi fraud control system, penerapan
                      Sistem Manajemen Anti Penyuapan (SMAP) ISO 37001:2016, dan
                      secara konsisten juga ikut serta dalam asesmen Good
                      Corporate Governance (GCG) setiap tahunnya yang dilakukan
                      oleh Badan Pemeriksa Keuangan dan Pembangunan (BPKP)
                      maupun konsultan internal.
                    </p>

                    <p class="text-justify">
                      Itu semua menurut Agus adalah bagian dari komitmen dalam
                      membangun kelengkapan sistem dan infrastruktur tata kelola
                      dan kepatuhan perusahaan. Sedangkan untuk penerapan
                      implementasi manajemen risiko, Agus mengutarakan jika
                      perusahaan melakukan pengelolaan risiko berbasis teknologi
                      informasi melalui aplikasi Prisma (Pupuk Indonesia Risk
                      Management System).
                    </p>

                    <p class="text-justify">
                      Selain itu, Agus menambahkan secara bersamaan, perseroan
                      juga sedang mengembangkan BCMS (Business Continuity
                      Management System). Sebuah sistem yang berfungsi untuk
                      melihat secara holistic dan mengidentifikasi ancaman
                      potensial serta yang berdampak kepada operasional
                      organisasi.
                    </p>

                    <p class="text-justify">
                      Terakhir, Agus menambahkan dengan implementasi GRC yang
                      optimal, setiap hasil review, evaluasi dan audit bisa
                      dijadikan pengembangan perbaikan.
                    </p>

                    <p class="text-justify">
                      “Maka bisnis perusahaan pun akan tetap aman dan tumbuh
                      dengan baik,” katanya {}
                    </p>
                  </div>
                </div>
              </div>
            </div>

      <div class="col-md-2 col-6 mb-3">
        <router-link class="card card-more" to="/pers">
          <div
            class="card-body text-start d-flex flex-column align-items-center justify-content-center"
          >
            <h5 class="card-title mb-0" style="text-align: center;">
              Siaran Pers Lainnya
            </h5>
            <img src="../assets/Arrow-right-resized.png" />
          </div>
        </router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "NewsCarousal",
};
</script>

<style scoped>
.card-fixed {
  width: 100%; /* Adjust as needed */
  height: 350px; /* Adjust as needed */
  box-shadow: 0 4px 8px rgba(0, 183, 255, 0.25);
  transition: transform 0.3s ease;
  border-radius: 10px;
}
/* .modal-content{
  border-radius: 0;
} */
.card-fixed:hover {
  box-shadow: 0 8px 16px rgba(0, 195, 255, 0.4); /* Adjust as needed */
  transform: scale(1.05);
}

.text-body-secondaryy {
  color: grey;
  font-style: italic;
  font-weight: 300;
}

.card-title {
  font-weight: 700;
  color: #084e8b;
}

.card-more {
  height: 100%;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 47, 255, 0.25);
  transition: transform 0.3s ease;
  border-radius: 10px;
}

.card-more:hover {
  box-shadow: 0 8px 16px rgba(0, 102, 255, 0.4); /* Adjust as needed */
  transform: scale(1.05);
}
.img-fixed {
  width: 100%; /* Adjust as needed */
  height: 150px; /* Adjust as needed */
  object-fit: cover;
}
.modal-title {
  font-weight: 700;
  color: #084e8b;
  font-style: italic;
  text-align: center;
  /* text-shadow: 2px 1px #00b7ff; */
}

.head-modal {
  font-weight: 600;
  color: #f15a24;
  font-size: x-large;
}
p {
  text-align: justify;
}
</style>
